import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  QueryList,
  SimpleChanges,
  ViewChildren,
  ViewContainerRef,
} from '@angular/core';
import Handsontable, { CellCoords } from 'handsontable';
import { environment } from 'src/environments/environment';
import {
  GetFormatListingGQL,
  GetPageAtterrissageListingGQL,
  GetRessourceNumeriqueListingByIdsGQL,
  GetRessourceNumeriqueListingByIdsQueryVariables,
  GetRessourceNumeriqueListingGQL,
  GetRessourceNumeriqueListingQueryVariables,
  UpdateRessourceNumeriqueGQL,
  UpdateRessourceNumeriqueMutationVariables,
} from '../../../../graphql/generated';
import { forkJoin, map, Observable, of, Subject, take } from 'rxjs';
import { extractEdgesAndNodes } from '../../graphql/operators/extract-edges-and-nodes';
import { DataChange } from '../../handsontable/types/data-change.interface';
import { HotTableRegisterer } from '@handsontable/angular';
import { RessourcesNumeriquesService } from '../../services/ressourcesNumeriques.service';
import { MessageService } from 'primeng/api';
import { ClassdefinitionService } from '../../services/classdefinition.service';
import { Classdefinition } from '../../model/classdefinition';
import { UserService } from '../../services/user.service';
import { AppComponent } from '../../app.component';
import { DegradedModeService } from '../../services/degraded-mod-service';
import frFR from 'handsontable/i18n/languages/fr-FR';
import { registerLanguageDictionary } from 'handsontable/i18n/registry';
import { dataRowToChangesArray } from 'handsontable/helpers';
import { Console } from 'console';

@Component({
  selector: 'app-ressources-numeriques',
  templateUrl: './ressources-numeriques.component.html',
  styleUrls: ['./ressources-numeriques.component.scss'],
})
export class RessourcesNumeriquesComponent
  implements AfterContentChecked, OnChanges
{
  @Input() ouvrageId: number;
  @Input() statutOuvrage: string;
  @Input() codeOuvrage: string;
  @Input() isReprise: boolean;
  @Input() dateCreationOuvrage: number;
  @Input() customCellProps: Array<Handsontable.CellMeta> = [];
  @Output() sendDataset: EventEmitter<Array<any>> = new EventEmitter();
  @Output() onDataChange: EventEmitter<any> = new EventEmitter();
  @Output() onLoadingDone: EventEmitter<any> = new EventEmitter();
  @Input() resetDataset: Observable<void> = new Subject();
  idTable = 'ressources_numeriques';
  ressources: any = [];
  dataChanges: Array<DataChange> = [];
  columns: Array<any> = [];
  settings: Handsontable.GridSettings;
  datasetCopy: Array<any>;
  text: string;
  selectedCategorie: string;
  selectedFormat: any;
  display: boolean = false;
  idTextEditor: CellCoords;
  uploadedFiles: any[] = [];
  classDef: Classdefinition;
  categories: any = [];
  formats: any = [];
  cibles: any = [];
  pages: any = [];
  originalDatas: any;
  rowToAddNumber: number = 1;
  displayCategories: boolean = false;
  displayFormats: boolean = false;
  displayPages: boolean = false;
  displayCible: boolean = false;
  displayHelpRestriction: boolean = false;
  dateDebutRestriction: Date = new Date(
    environment.DateDebutRestrictionOuvrage,
  );
  displayValidationError: boolean = false;
  validationErrorRows: Array<{
    ligne: number;
    structureInvalid: boolean;
    folioInvalid: boolean;
  }> = [];
  private structureFormatRegex = /^t\d{2}c\d{2}$/;
  private folioFormatRegex = /^\d{3,4}$/;

  /**
   * Une cellule vide est autorisée : on crée souvent la ligne d'abord (ID,
   * minilien) et on renseigne Structure / N° folio plus tard. Le format
   * n'est vérifié que si une valeur est saisie (un espace seul n'est pas
   * considéré comme vide et reste invalide).
   */
  private isEmptyValue(value: unknown): boolean {
    return value === null || value === undefined || value === '';
  }

  private isStructureValid(value: unknown): boolean {
    return this.isEmptyValue(value) || this.structureFormatRegex.test(String(value));
  }

  private isFolioValid(value: unknown): boolean {
    return this.isEmptyValue(value) || this.folioFormatRegex.test(String(value));
  }
  loadingUpload: boolean = false;
  selectedPage: any;
  selectedCible: string;
  currentRowIndex: number = -1;
  //Filters
  localStorageFilterKey = '';
  hasSavedFilter: boolean = false;

  isDegradedMod: boolean = false;

  protected checkboxColNames = [
    'verouille',
    'OGRNPlay',
    'misEnAvant',
    'Max',
    'Lib',
    'siteBelinEducation',
    'pearltrees',
    'minilienEdubelin',
  ];

  protected colToolTip = [
    'En attente de description pour la colonne 0\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 1\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 2\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 3\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 4\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 5\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 6\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 7\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 8\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 9\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 10\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 11\n On peut faire des sauts de lignes sans problèmes',
    'En attente de description pour la colonne 12\n On peut faire des sauts de lignes sans problèmes',
  ];
  @ViewChildren('dialogs') private dialogs: QueryList<ElementRef>;
  private hotRegisterer = new HotTableRegisterer();
  private targetCell: HTMLTableCellElement;
  private hotInstance: Handsontable;

  constructor(
    private service: GetRessourceNumeriqueListingGQL,
    private graphqlQLRnByIds: GetRessourceNumeriqueListingByIdsGQL,
    private updateService: UpdateRessourceNumeriqueGQL,
    private ressourceNumeriqueService: RessourcesNumeriquesService,
    private pageService: GetPageAtterrissageListingGQL,
    private componentFactoryResolver: ComponentFactoryResolver,
    public viewContainerRef: ViewContainerRef,
    private changeDetectorRef: ChangeDetectorRef,
    private messageService: MessageService,
    private classDefinition: ClassdefinitionService,
    public userService: UserService,
    private formatService: GetFormatListingGQL,
    public degradedModeService: DegradedModeService,
  ) {
    this.loadDataList().subscribe({
      next: (value) => {
        this.initSettings();
      },
      error: (err) => {},
    });
  }

  ngOnInit() {
    this.loadRessourcesNumeriques();
    this.degradedModeService.isDegradedMode().subscribe((isDegradedMode) => {
      this.isDegradedMod = isDegradedMode;
    });
  }

  /**
   * dateCreationOuvrage arrive souvent après le chargement des ressources
   * (requête getOuvrage séparée et plus lente que celle des ressources) :
   * isRestrictionActive() vaut donc false au premier passage dans
   * initCellSettings. On revalide les cellules Structure / N° folio dès que
   * la vraie date de création est connue.
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['dateCreationOuvrage']) {
      this.refreshStructureFolioValidity();
    }
  }

  refreshStructureFolioValidity() {
    // getInstance() lève une exception (au lieu de retourner undefined)
    // si la table Handsontable n'est pas encore montée, ce qui arrive au
    // tout premier ngOnChanges (avant l'initialisation de app-handsontable).
    let instance: Handsontable | undefined;
    try {
      instance = this.hotRegisterer.getInstance(this.idTable);
    } catch (e) {
      return;
    }
    if (!instance || instance.isDestroyed) {
      return;
    }
    const colStructureId = Number(instance.propToCol('structure'));
    const colNumeroFolioId = Number(instance.propToCol('numeroFolio'));
    for (let row = 0; row < instance.countRows(); row++) {
      this.updateStructureFolioValidity(
        instance,
        row,
        colStructureId,
        colNumeroFolioId,
        instance.getDataAtCell(row, colStructureId),
        instance.getDataAtCell(row, colNumeroFolioId),
      );
    }
    instance.render();
  }

  /**
   * Ce hook doit être ajouté via instance.addHook() et non via la clé
   * `afterChange` de `this.settings` : ce settings object est fusionné
   * dans handsontable.component.ts par `{...wrapperSettings, ...settings}`,
   * donc un `afterChange` défini ici écraserait celui du wrapper qui
   * calcule dataChanges et émet onDataChange (plus aucune sauvegarde ne
   * partirait). addHook() s'ajoute en plus des hooks existants, sans rien
   * remplacer.
   */
  private structureFolioHookRegistered = false;
  registerStructureFolioChangeHook(instance) {
    if (this.structureFolioHookRegistered) {
      return;
    }
    this.structureFolioHookRegistered = true;
    instance.addHook('afterChange', (changes, source) => {
      if (!changes || source === 'loadData') {
        return;
      }
      const colStructureId = Number(instance.propToCol('structure'));
      const colNumeroFolioId = Number(instance.propToCol('numeroFolio'));
      const touchedRows = new Set<number>();
      changes.forEach(([row, prop]) => {
        if (prop === 'structure' || prop === 'numeroFolio') {
          touchedRows.add(row);
        }
      });
      if (touchedRows.size === 0) {
        return;
      }
      touchedRows.forEach((row) => {
        this.updateStructureFolioValidity(
          instance,
          row,
          colStructureId,
          colNumeroFolioId,
          instance.getDataAtCell(row, colStructureId),
          instance.getDataAtCell(row, colNumeroFolioId),
        );
      });
      instance.render();
    });
  }

  loadChangedRessourcesNumeriques(changedIds) {
    const variables: GetRessourceNumeriqueListingByIdsQueryVariables = {
      after: 0,
      ids: changedIds.join(','),
    };
    this.graphqlQLRnByIds
      .watch(variables)
      .valueChanges.pipe(
        map((result) => result.data.getRessourceNumeriqueListing),
        extractEdgesAndNodes(),
      )
      .subscribe({
        next: (values) => {
          var self = this;
          const enrichedValues = this.enrichData(values);
          for (let enrichedValue of enrichedValues) {
            let index = this.ressources.findIndex(
              (r) =>
                Number.parseInt(r.id) === Number.parseInt(enrichedValue['id']),
            );
            if (index > -1) {
              this.ressources[index] = enrichedValue;
            }
          }

          // Tri des ressources par la colonne "ordre"
          // les ... sont pour obligé handsontable a considrer les valeur comme un nouveau tableau ce
          // qu'évite le bug de la modif non prise en compte apres cette fonction
          this.ressources = [...this.ressources].sort(
            (a, b) => a.ordre - b.ordre,
          );
          this.getHotInstance().updateData(this.ressources);
          this.processSavedFilters();
          this.onDataChange.emit({});
          return true;
        },
        error: (err) => {
          return false;
        },
      });
    return of(false);
  }

  loadRessourcesNumeriques(
    variables?: GetRessourceNumeriqueListingQueryVariables,
  ): Observable<boolean> {
    if (variables == undefined) {
      var filterOuvrageId = {};
      filterOuvrageId['ouvrage__id'] = this.ouvrageId;
      variables = {
        after: 0,
        filter: JSON.stringify(filterOuvrageId),
      };
    }
    this.service
      .watch(variables)
      .valueChanges.pipe(
        map((result) => result.data.getRessourceNumeriqueListing),
        extractEdgesAndNodes(),
      )
      .subscribe({
        next: (values) => {
          var self = this;
          this.ressources = this.enrichData(values);
          this.originalDatas = JSON.parse(JSON.stringify(values));
          let instance = this.hotRegisterer.getInstance(this.idTable);
          instance.loadData(this.ressources);
          this.registerStructureFolioChangeHook(instance);
          // init cell settings
          const data = instance.getData();
          const colVerouilleId = instance.propToCol('verouille');
          const colStructureId = instance.propToCol('structure');
          const colNumeroFolioId = instance.propToCol('numeroFolio');
          const colCategorieId = instance.propToCol('categorie');
          const colFormatId = instance.propToCol('format.id');
          const colNomId = instance.propToCol('nom');
          for (let i = 0; i < instance.countRows(); i++) {
            this.initCellSettings(
              instance,
              i,
              data[i],
              colVerouilleId,
              colStructureId,
              colNumeroFolioId,
              colCategorieId,
              colFormatId,
              colNomId,
            );
          }
          this.processSavedFilters();
          this.onLoadingDone.emit();

          return true;
        },
        error: (err) => {
          return false;
        },
      });
    return of(false);
  }

  saveChanges(event) {
    this.dataChanges = event;
    this.onDataChange.emit(this.dataChanges);
  }

  /**
   *
   * @param changes
   * This function is used to update the value of the checkbox changes,
   * because the checkbox changes are not updated with the new value in the
   * changes array, so we need to update them with the current value of
   *  the checkbox in the ressources array
   * @returns
   */
  updateCheckboxValueChange(changes) {
    Object.keys(changes).forEach((rnId) => {
      const ressource = this.ressources.find(
        (r) => Number.parseInt(r.id) === Number(rnId),
      );
      if (ressource) {
        changes[rnId].forEach((colChange) => {
          const colName = colChange.column;
          if (this.checkboxColNames.includes(colName)) {
            const currentValue = ressource[colName];
            colChange.value = currentValue;
          }
        });
      }
    });
    return changes;
  }

  saveAllChanges() {
    this.onDataChange.emit(this.dataChanges);
  }

  resetDatasetHistory() {
    if (!this.hotRegisterer.getInstance(this.idTable).isDestroyed) {
      this.hotRegisterer
        .getInstance(this.idTable)
        .getCellsMeta()
        .forEach((cellMeta) => {
          if (cellMeta.className?.toString().includes('edited-cell')) {
            cellMeta.className = cellMeta.className
              .toString()
              .replace(' edited-cell', '');
            this.hotRegisterer
              .getInstance(this.idTable)
              .setCellMetaObject(cellMeta.row, cellMeta.col, cellMeta);
          }
        });
      this.hotRegisterer.getInstance(this.idTable).render();
    }
  }

  updateRessource(id, input) {
    const variables: UpdateRessourceNumeriqueMutationVariables = {
      id: id,
      input: input,
    };

    this.updateService.mutate(variables).subscribe({
      next: (value) => {},
      error: (err) => {},
    });
  }

  createRessourceNumerique($event) {
    const amount = $event.amount;
    this.ressourceNumeriqueService.create(this.ouvrageId, amount).subscribe({
      next: (data) => {
        // this.loadRessourcesNumeriques()

        var filterOuvrageId = {};
        filterOuvrageId['ouvrage__id'] = this.ouvrageId;

        const variables: GetRessourceNumeriqueListingQueryVariables = {
          filter: JSON.stringify(filterOuvrageId),
        };

        this.service
          .watch(variables)
          .valueChanges.pipe(
            map((result) => result.data.getRessourceNumeriqueListing),
            extractEdgesAndNodes(),
          )
          .subscribe({
            next: (values) => {
              var self = this;

              for (let i = 0; i < amount; i++) {
                let index = $event.row + i;
                this.ressources[index]['id'] = data[i]['id'];
                this.ressources[index]['ordre'] = data[i]['ordre'];
                this.originalDatas[index] = {};
                this.originalDatas[index]['id'] = data[i]['id'];
                this.originalDatas[index]['ordre'] = data[i]['ordre'];

                //Pour éviter l'erreur du bouton disable si isReprise est true
                this.ressources[index]['ouvrage'] = {
                  is_reprise:
                    this.originalDatas?.[0]?.ouvrage?.is_reprise ?? false,
                };

                let instance = this.hotRegisterer.getInstance(this.idTable);
                const colOrdreId = parseInt(instance.propToCol('ordre'));
                instance.setDataAtCell(
                  Number(index),
                  colOrdreId,
                  data[i]['ordre'],
                );
              }

              return true;
            },
            error: (err) => {
              return false;
            },
          });
      },
      error: (err) => {},
    });
  }

  enrichData(value: any) {
    var enrichDatas: Array<Object> = [];

    value.forEach(function (item) {
      var newItem = item;
      newItem.minilien =
        item.miniliens.length > 0 ? item.miniliens[0].url_courte : null;
      newItem.lienFichier =
        item.miniliens.length > 0 ? item.miniliens[0].url_longue : null;
      enrichDatas.push(newItem);
    });
    return enrichDatas;
  }

  insertRow() {
    let ressourcesCount = this.ressources.length;
    this.hotRegisterer
      .getInstance(this.idTable)
      .alter('insert_row_below', ressourcesCount, this.rowToAddNumber);
    this.rowToAddNumber = 1;
  }

  deleteRessourceNumerique(id) {
    this.ressourceNumeriqueService.delete(id).subscribe({
      next: (data) => {
        this.loadRessourcesNumeriques();
      },
      error: (err) => {},
    });
  }

  onBasicUpload(event, id) {
    this.loadingUpload = true;
    for (const file of event.files) {
      this.uploadedFiles.push(file);
    }

    this.ressourceNumeriqueService
      .uploadFile(id, event)
      .subscribe({
        next: (data) => {
          this.messageService.add({
            key: 'update',
            severity: 'success',
            summary: 'Fichier uploadé avec succès',
          });
          this.loadRessourcesNumeriques();
          this.uploadedFiles = [];
        },
        error: (err) => {
          this.messageService.add({
            key: 'update',
            severity: 'error',
            summary: "Erreur pendant l'upload du fichier",
          });
          this.uploadedFiles = [];
        },
      })
      .add(() => {
        this.loadingUpload = false;
      });
  }

  deleteAsset(idRessource, idAsset) {
    this.ressourceNumeriqueService.deleteAsset(idRessource, idAsset).subscribe({
      next: (data) => {
        this.loadRessourcesNumeriques().subscribe({
          next: (data) => {
            this.changeDetectorRef.detectChanges();
            this.dialogs.changes.pipe(take(1)).subscribe((queryChanges) => {
              this.dialogs.forEach((child) => {
                var id = child.nativeElement.id.replace(
                  'fileUploadDialog_',
                  '',
                );
                child.nativeElement.close();
                if (id === idRessource) {
                  child.nativeElement.showModal();
                }
              });
            });
          },
          error: (err) => {},
        });
      },
      error: (err) => {},
    });
  }

  ngAfterContentChecked() {
    this.changeDetectorRef.detectChanges();
  }

  closeDialog($event: MouseEvent) {
    let target = $event.target as HTMLElement;
    let dialog = target.closest('dialog') as HTMLDialogElement;

    dialog.close();
  }

  async loadPages(ids?: any) {
    let variables = {};
    let filterOuvrageId = {};
    filterOuvrageId['ouvrage__id'] = this.ouvrageId;
    variables = {
      filter: JSON.stringify(filterOuvrageId),
    };
    if (ids) {
      const idsString = Array.isArray(ids) ? ids.join(',') : ids.toString();
      variables = {
        ...variables,
        ids: idsString,
      };
    }
    if (!this.pages || this.pages.length === 0) {
      this.pages = [];
    }
    this.pageService
      .watch(variables)
      .valueChanges.pipe(
        map((result) => result.data.getPageAtterrissageListing),
        extractEdgesAndNodes(),
      )
      .subscribe({
        next: (value) => {
          for (const entry of value) {
            const pageIndex = this.pages.findIndex(
              (page) => page.id === entry.id,
            );
            // If the page is not already in the list, add it. Otherwise, update the existing entry.
            if (pageIndex === -1) {
              this.pages.push({ pageId: entry.idPage, id: entry.id });
            } else {
              this.pages[pageIndex] = { pageId: entry.idPage, id: entry.id };
            }
          }
        },
        error: (err) => {},
      });
  }

  downloadFile(idRessource) {
    this.ressourceNumeriqueService.downloadAsset(idRessource).subscribe({
      next: (data) => {
        let blob = new Blob([data.body]);
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = data.headers.get('filename');
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  updateVerouillage() {
    let datas = this.hotRegisterer.getInstance(this.idTable).getData();

    for (const data of datas as Array<any>) {
      var id = Number(data[0]);
      var input = {};
      input['verouille'] = data[1];

      const variables: UpdateRessourceNumeriqueMutationVariables = {
        id: id,
        input: input,
      };

      this.updateService.mutate(variables).subscribe({
        next: (value) => {
          this.loadRessourcesNumeriques();
        },
        error: (err) => {},
      });
    }
  }

  setTextCell() {
    let instance = this.hotRegisterer.getInstance(this.idTable);

    if (
      typeof this.ressources[instance.toPhysicalRow(this.idTextEditor.row)] !==
      'undefined'
    ) {
      var PREFIX = '<p>';
      var SUFFIX = '</p>';
      let text = this.text;

      if (text.startsWith(PREFIX)) {
        text = this.text.slice(PREFIX.length);
      }

      if (text.endsWith(SUFFIX)) {
        text = text.slice(0, -SUFFIX.length);
      }
      instance.setDataAtCell(
        this.idTextEditor.row,
        this.idTextEditor.col,
        text,
      );
    }
  }

  setCategorie() {
    let instance = this.hotRegisterer.getInstance(this.idTable);

    instance.setDataAtCell(
      this.idTextEditor.row,
      this.idTextEditor.col,
      this.selectedCategorie,
    );
  }

  setFormat() {
    let instance = this.hotRegisterer.getInstance(this.idTable);

    const index = this.formats.findIndex(
      (x) => x.value === this.selectedFormat,
    );
    let format = {
      nom: this.formats[index].key,
      id: this.formats[index].value,
    };
    instance.setDataAtCell(
      this.idTextEditor.row,
      this.idTextEditor.col,
      this.formats[index].value,
    );
  }

  setPage() {
    let instance = this.hotRegisterer.getInstance(this.idTable);
    instance.setDataAtCell(
      this.idTextEditor.row,
      this.idTextEditor.col,
      this.selectedPage.join(','),
    );
  }

  setCible() {
    let instance = this.hotRegisterer.getInstance(this.idTable);

    instance.setDataAtCell(
      this.idTextEditor.row,
      this.idTextEditor.col,
      this.selectedCible,
    );
  }

  autoClose(type) {
    switch (type) {
      case 'categorie':
        this.setCategorie();
        this.displayCategories = false;
        break;
      case 'format':
        this.setFormat();
        this.displayFormats = false;
        break;
      case 'cible':
        this.setCible();
        this.displayCible = false;
        break;
    }
  }

  /**
   * Update cell settings
   * @param instance
   * @param row
   * @param col
   * @param cellProperties
   * @param data
   * @param colVerouilleId
   * @param colStructureId
   * @param colNumeroFolioId
   * @param colCategorieId
   * @param colFormatId
   * @param colNomId
   */
  initCellSettings(
    instance,
    row,
    data,
    colVerouilleId,
    colStructureId,
    colNumeroFolioId,
    colCategorieId,
    colFormatId,
    colNomId,
  ) {
    if (data) {
      if (
        data[colStructureId] === null ||
        data[colNumeroFolioId] === null ||
        data[colCategorieId] === null ||
        data[colFormatId] === null
      ) {
        this.applyReadOnlyCellProperties(instance, row, colVerouilleId);
      }

      if (data[colStructureId] === true) {
        this.applyReadOnlyCellProperties(instance, row, colStructureId);
        this.applyReadOnlyCellProperties(instance, row, colNumeroFolioId);
        this.applyReadOnlyCellProperties(instance, row, colNomId);
      }

      this.updateStructureFolioValidity(
        instance,
        row,
        colStructureId,
        colNumeroFolioId,
        data[colStructureId],
        data[colNumeroFolioId],
      );
    }
  }

  /**
   * Les restrictions de colonnes (folio, structure, ...) ne s'appliquent
   * qu'aux ouvrages créés après la date définie par DateDebutRestrictionOuvrage
   */
  isRestrictionActive(): boolean {
    if (!this.dateCreationOuvrage) {
      return false;
    }
    // creationDate Pimcore est un timestamp en secondes
    return this.dateCreationOuvrage * 1000 > this.dateDebutRestriction.getTime();
  }

  /**
   * Colore en rouge les cellules Structure / N° folio dont la valeur ne
   * respecte pas le format attendu, uniquement quand la restriction de
   * format est active pour cet ouvrage (cf isRestrictionActive).
   */
  updateStructureFolioValidity(
    instance,
    row,
    colStructureId,
    colNumeroFolioId,
    structureValue,
    folioValue,
  ) {
    const restrictionActive = this.isRestrictionActive();
    this.toggleInvalidCellClass(
      instance,
      row,
      colStructureId,
      restrictionActive && !this.isStructureValid(structureValue),
    );
    this.toggleInvalidCellClass(
      instance,
      row,
      colNumeroFolioId,
      restrictionActive && !this.isFolioValid(folioValue),
    );
  }

  toggleInvalidCellClass(instance, row, col, isInvalid: boolean) {
    if (typeof col !== 'number' || col < 0 || Number.isNaN(col)) {
      // propToCol('structure'/'numeroFolio') renvoie la prop elle-même
      // (une string, pas -1 : cf handsontable/dataMap/dataMap.js#propToCol)
      // si cette méthode est appelée avant que initColumns() (chaîne
      // asynchrone classDefinition/GraphQL indépendante de
      // loadRessourcesNumeriques) n'ait enregistré les colonnes sur
      // l'instance Handsontable. getCellMeta() avec un index non-numérique
      // lève une exception qui, sinon, interromprait tout
      // initCellSettings() et bloquerait le chargement de la grille.
      return;
    }
    const cellProperties = instance.getCellMeta(row, col);
    const classes = (cellProperties['className'] || '')
      .toString()
      .split(' ')
      .filter((c) => c && c !== 'invalid-cell');
    if (isInvalid) {
      classes.push('invalid-cell');
    }
    cellProperties['className'] = classes.join(' ');
    instance.setCellMeta(row, col, cellProperties);
  }

  /**
   * Vérifie l'ensemble des lignes du tableau et retourne celles dont la
   * colonne Structure et/ou N° folio est invalide. Utilisé pour bloquer la
   * sauvegarde tant que la restriction de format n'est pas respectée.
   */
  getInvalidStructureFolioRows(): Array<{
    ligne: number;
    structureInvalid: boolean;
    folioInvalid: boolean;
  }> {
    if (!this.isRestrictionActive()) {
      return [];
    }
    const instance = this.hotRegisterer.getInstance(this.idTable);
    const colStructureId = Number(instance.propToCol('structure'));
    const colNumeroFolioId = Number(instance.propToCol('numeroFolio'));
    const invalidRows: Array<{
      ligne: number;
      structureInvalid: boolean;
      folioInvalid: boolean;
    }> = [];
    for (let row = 0; row < instance.countRows(); row++) {
      const structureValue = instance.getDataAtCell(row, colStructureId);
      const folioValue = instance.getDataAtCell(row, colNumeroFolioId);
      const structureInvalid = !this.isStructureValid(structureValue);
      const folioInvalid = !this.isFolioValid(folioValue);
      if (structureInvalid || folioInvalid) {
        invalidRows.push({ ligne: row + 1, structureInvalid, folioInvalid });
      }
    }
    return invalidRows;
  }

  displayValidationErrorModal(invalidRows) {
    this.validationErrorRows = invalidRows;
    this.displayValidationError = true;
  }

  applyReadOnlyCellProperties(instance, row, col) {
    const cellProperties = instance.getCellMeta(row, col);
    cellProperties['readOnly'] = true;
    cellProperties['className'] = 'desactive';
    instance.setCellMeta(row, col, cellProperties);
  }

  /* FILTERS PART*/

  /**
   * Save the current filters to local storage
   * @returns {void}
   */
  saveFilter() {
    const filters = this.hotRegisterer
      .getInstance(this.idTable)
      .getPlugin('filters')
      .exportConditions();
    if (filters.length === 0) {
      this.messageService.add({
        key: 'update',
        severity: 'warn',
        summary: 'Aucun filtre à sauvegarder',
      });
      return;
    }
    this.messageService.add({
      key: 'update',
      severity: 'success',
      summary: 'Vos filtres ont été sauvegardés avec succès',
    });
    this.hasSavedFilter = true;
    localStorage.setItem(
      this.getLocalStorageFilterKey(),
      JSON.stringify(filters),
    );
  }

  /**
   * Delete them from local storage
   * @returns {void}
   */
  deleteFilter() {
    if (localStorage.getItem(this.getLocalStorageFilterKey()) === null) {
      this.messageService.add({
        key: 'update',
        severity: 'warn',
        summary: 'Aucun filtre à supprimés',
      });
      return;
    }
    localStorage.removeItem(this.getLocalStorageFilterKey());
    this.hasSavedFilter = false;
    this.hotRegisterer
      .getInstance(this.idTable)
      .getPlugin('filters')
      .clearConditions();
    this.hotRegisterer.getInstance(this.idTable).getPlugin('filters').filter();
    this.messageService.add({
      key: 'update',
      severity: 'success',
      summary: 'Vos filtres ont été supprimés avec succès',
    });
  }

  /**
   * Get the key to store filters in local storage
   * @returns {string} The key for local storage
   */
  getLocalStorageFilterKey() {
    if (this.localStorageFilterKey.length === 0) {
      const idOuvrage = this.ouvrageId;
      if (idOuvrage === null || idOuvrage === undefined) {
        this.messageService.add({
          key: 'update',
          severity: 'error',
          summary:
            'Erreur : code ouvrage non trouvé , sauvegarde des filtres impossible veuillez réessayer',
        });
      }
      const user =
        this.userService.getUserFirstName() +
        '_' +
        this.userService.getUserLastName();
      this.localStorageFilterKey = 'filters_rn_' + idOuvrage + '_' + user;
    }
    return this.localStorageFilterKey;
  }

  /**
   * Process saved filters from local storage
   */
  processSavedFilters() {
    const filters = localStorage.getItem(this.getLocalStorageFilterKey());
    if (filters !== null) {
      this.hotRegisterer
        .getInstance(this.idTable)
        .getPlugin('filters')
        .importConditions(JSON.parse(filters));
      this.hotRegisterer
        .getInstance(this.idTable)
        .getPlugin('filters')
        .filter();
      this.hasSavedFilter = true;
    }
  }

  /* END FILTERS PART*/

  private initColumns(): void {
    var self = this;
    this.columns = [
      {
        data: 'id',
        title: 'id',
        readOnly: true,
        type: 'text',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: null,
        readOnly: true,
        width: 40,
        className: 'comment-col',
        renderer: (instance, td, row, col, prop, value, cellProperties) => {
          const ressource =
            self.ressources[
              self.hotRegisterer.getInstance(self.idTable).toPhysicalRow(row)
            ];
          const hasCommentaire = !!ressource.commentaires;
          td.className = 'darkmode-comment-col';
          td.innerHTML = hasCommentaire
            ? '<span class="pi pi-comments" style="color: #5e8f32; font-size: 1.2em;" title="Commentaire disponible"></span>'
            : '';

          td.style.border = 'none';
          td.style.background = 'transparent';
          td.style.display = 'flex';
          td.style.justifyContent = 'center';
          td.style.alignItems = 'center';
        },
      },
      {
        data: 'verouille',
        title: 'Verrouillage',
        readOnly: !this.userService.canEdit(),
        type: 'checkbox',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'OGRNPlay',
        title: 'OGRN Play',
        readOnly: !this.userService.canEdit(),
        type: 'checkbox',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'titreEditeur',
        title: 'Titre de la ressource',
        readOnly: !this.userService.canEdit(),
        renderer: 'html',
        type: 'text',
        className: this.userService.canEdit()
          ? 'label open_text_editor'
          : 'label open_text_editor desactive',
      },
      {
        data: 'pagesIds',
        title: "Id page d'atterrissage",
        readOnly: !this.userService.canEdit(),
        type: 'text',
        fillHandle: 'vertical',
        source: self.pages,
        className: this.userService.canEdit()
          ? 'label show_pages'
          : 'label show_pages desactive',
        trimDropdown: false,
        height: 100,
      },
      {
        data: 'nom',
        title: 'Id ressource',
        readOnly: !this.userService.canEdit(),
        type: 'text',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
        validator: function validateUnique(value, callback) {
          var data = this.instance.getDataAtCol(this.col);
          var index = data.indexOf(value);
          var valid = true;
          if (index > -1 && this.row !== index) {
            valid = false;
          }
          return callback(valid);
        },
      },
      {
        data: 'structure',
        title: 'Structure',
        readOnly: !this.userService.canEdit(),
        type: 'text',
        // La cellule reste éditable même si le format est invalide : le
        // retour visuel (cellule rouge) et le blocage à la sauvegarde
        // suffisent, plus besoin de bloquer la sortie de cellule.
        allowInvalid: true,
        className: this.userService.canEdit() ? 'label' : 'label desactive',
        validator: function StructureValidator(value, callback) {
          if (self.isRestrictionActive()) {
            // 6 caractères : t minuscule, 2 chiffres, c minuscule, 2 chiffres (ex : t01c02)
            return callback(self.isStructureValid(value));
          }
          return callback(true);
        },
      },
      {
        data: 'numeroFolio',
        title: 'N° folio',
        readOnly: !this.userService.canEdit(),
        type: 'text',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
        // Idem colonne Structure : on laisse sortir de la cellule, la
        // cellule rouge + le blocage à la sauvegarde suffisent.
        allowInvalid: true,
        validator: function NumberValidator(value, callback) {
          if (self.isRestrictionActive()) {
            return callback(self.isFolioValid(value));
          }
          return callback(self.isEmptyValue(value) || /^\d+$/.test(value));
        },
      },
      {
        data: 'ordre',
        title: 'Ordre',
        readOnly: !this.userService.canEdit(),
        type: 'numeric',
        numericFormat: { pattern: '0' },
        className: this.userService.canEdit() ? 'label' : 'label desactive',
        allowInvalid: false,
        validator: function validateUniqueOrdre(value, callback) {
          var data = this.instance.getDataAtCol(this.col);
          var numVal = Number(value);
          var valid = true;
          for (var i = 0; i < data.length; i++) {
            if (i !== this.row && Number(data[i]) === numVal) {
              valid = false;
              break;
            }
          }
          return callback(valid);
        },
      },
      {
        data: 'categorie',
        title: 'Catégorie',
        readOnly: !this.userService.canEdit(),
        type: 'key-value-list',
        className: this.userService.canEdit()
          ? 'label show_categories'
          : 'show_categories label desactive',
        source: self.categories,
        allowInvalid: false,
      },
      {
        data: 'format.id',
        title: 'Format',
        readonly: !this.userService.canEdit(),
        type: 'text',
        className: this.userService.canEdit()
          ? 'label show_formats'
          : 'show_formats label desactive',
        allowInvalid: false,
        renderer(instance, td, row, col, prop, value, cellProperties) {
          td.innerHTML = '';
          const divSelect = '<div class="htAutocompleteArrow">▼</div>';
          // Rendu appelé aussi par le GhostTable d'autoColumnSize, avec des
          // lignes d'échantillonnage qui ne correspondent pas forcément 1:1
          // à self.ressources (et format peut être null/absent) : un accès
          // non protégé ici lève une exception qui casse tout le calcul de
          // dimensions du tableau (plus aucune cellule ne se rend, sur
          // toutes les colonnes), d'où l'usage systématique de `?.`.
          const formatId =
            self.ressources[
              self.hotRegisterer.getInstance(self.idTable)?.toPhysicalRow(row)
            ]?.format?.id;
          if (formatId !== undefined && formatId !== null) {
            const index = self.formats.findIndex((x) => x.value === formatId);
            if (self.formats[index]) {
              td.innerHTML = divSelect + ' ' + self.formats[index].key;
            } else td.innerHTML = divSelect;
          } else {
            td.innerHTML = divSelect;
          }

          td.className = self.userService.canEdit()
            ? 'label show_formats'
            : 'show_formats label desactive';

          return td;
        },
      },
      {
        data: 'fichier',
        readOnly: true,
        title: 'Fichier',
        renderer(instance, td, row, col, prop, value, cellProperties) {
          td.innerHTML = '';
          let physicalRow = self.hotRegisterer
            .getInstance(self.idTable)
            .toPhysicalRow(row);
          var catValue = self.ressources[physicalRow].categorie;
          var id = self.ressources[physicalRow].id;
          var medias = self.ressources[physicalRow].medias;
          let disabled = 'disabled=disabled';
          if (typeof self.ressources[physicalRow] !== 'undefined') {
            if (
              self.ressources[physicalRow].categorie !== '' &&
              self.ressources[physicalRow].format !== ''
            ) {
              disabled =
                self.ressources[physicalRow].verouille === true
                  ? ''
                  : 'disabled=disabled';
            }
          }

          if (!self.userService.canEdit()) {
            disabled = 'disabled=disabled';
            td.className = 'desactive';
          }

          if (catValue != 'url') {
            if (
              !medias ||
              medias.length === 0 ||
              (medias[0]['id'] === null && self.isDegradedMod)
            ) {
              td.innerHTML =
                '<button style="display:block; margin:auto" class="rn_fileupload p-element p-button-rounded p-button-warning p-button p-component" ' +
                disabled +
                ' data-id="' +
                id +
                '">Upload</button>';
            } else {
              td.innerHTML =
                '<button style="display:block; margin:auto" class="rn_filedownload p-element p-button-rounded p-button-success p-button p-component" data-id="' +
                id +
                '">Télécharger</button>';
            }
            td.style = 'vertical-align:middle';
          } else {
            td.innerHTML = '';
          }
          return td;
        },
      },
      {
        data: 'nomFichier',
        readOnly: true,
        wordWrap: true,
        className: 'desactive',
        width: 300,
        title: 'Nom fichier',
        renderer(instance, td, row, col, prop, value, cellProperties) {
          td.innerHTML = '';
          let physicalRow = self.hotRegisterer
            .getInstance(self.idTable)
            .toPhysicalRow(row);
          var catValue = self.ressources[physicalRow].categorie;
          if (catValue != 'url') {
            let filename =
              self.ressources[physicalRow].filename !== null
                ? self.ressources[physicalRow].filename
                : '';
            td.innerHTML = '<span>' + filename + '</span>';
            td.className = 'desactive copy_to_clipboard';
          } else {
            if (!self.userService.canEdit()) {
              td.className = 'desactive copy_to_clipboard';
            }
            td.innerHTML = '';
          }

          return td;
        },
      },
      {
        data: 'url',
        title: 'Url',
        readOnly: !this.userService.canEdit(),
        type: 'text',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'idAstra',
        title: 'Id Astra',
        readOnly: !this.userService.canEdit(),
        type: 'text',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'minilien',
        title: 'Minilien',
        readOnly: true,
        type: 'text',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
        renderer: (instance, td, row, col, prop, value, cellProperties) => {
          td.textContent = '';
          //physcial row car le tri et les filtres peuvent changer l'ordre des lignes
          let physicalRow = instance.toPhysicalRow(row);
          let miniliens = self.ressources[physicalRow].miniliens;
          if (miniliens?.length >= 1) {
            const miniliensString = miniliens
              // on prends que les miniliens normaux
              .filter(
                (minilien) =>
                  minilien.type_minilien === 'normal' ||
                  minilien.type_minilien === null,
              )
              // on affiche que les url courtes
              .map((minilien) => minilien.url_courte)
              // on les sépare par un saut de ligne
              .join('<br>');
            td.innerHTML = miniliensString;
          }
          return td;
        },
      },
      {
        readOnly: true,
        metaTitle: 'Prévisualisation',
        title: 'Prévisualisation',
        renderer(instance, td, row, col, prop, value, cellProperties) {
          td.innerHTML = '';
          let fileName = self.ressources[instance.toPhysicalRow(row)].filename;
          // Render a preview button if there is a file associated with the resource
          if (fileName) {
            td.innerHTML =
              '<button style="display:flex; margin:auto" icon="pi pi-plus" ' +
              'class="p-element p-button-rounded p-button-success p-button p-component p-button-icon-only  ng-star-inserted b-preview">' +
              '<span class="pbutton-icon pi pi-external-link"></span>' +
              '</button>';
          }
          return td;
        },
      },
      {
        data: 'titreGrain',
        title: 'Titre du grain',
        readOnly: !this.userService.canEdit(),
        type: 'text',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'libelleAction',
        title: "Libellé de l'action",
        readOnly: !this.userService.canEdit(),
        type: 'text',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'debutVideo',
        title: 'Début vidéo en secondes',
        width: 180,
        readOnly: !this.userService.canEdit(),
        type: 'numeric',
        numericFormat: { pattern: '0' },
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'finVideo',
        title: 'Fin vidéo en secondes',
        width: 160,
        readOnly: !this.userService.canEdit(),
        type: 'numeric',
        numericFormat: { pattern: '0' },
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'cible',
        title: 'Cible',
        width: 95,
        readOnly: !this.userService.canEdit(),
        type: 'key-value-list',
        source: self.cibles,
        className: this.userService.canEdit()
          ? 'label disable-edit show_cible'
          : 'label disable-edit show_cible desactive',
      },
      {
        data: 'misEnAvant',
        title: 'Mise en avant Max',
        width: 140,
        readOnly: !this.userService.canEdit(),
        type: 'checkbox',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'Max',
        title: 'Max',
        width: 60,
        readOnly: !this.userService.canEdit(),
        type: 'checkbox',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'Lib',
        title: 'Lib',
        width: 60,
        readOnly: !this.userService.canEdit(),
        type: 'checkbox',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'siteBelinEducation',
        title: 'Site belin éducation',
        width: 145,
        readOnly: !this.userService.canEdit(),
        type: 'checkbox',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'pearltrees',
        width: 90,
        title: 'Pearltrees',
        readOnly: !this.userService.canEdit(),
        type: 'checkbox',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'minilien',
        title: 'Minilien pearltrees',
        readOnly: true,
        type: 'text',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
        renderer: (instance, td, row, col, prop, value, cellProperties) => {
          td.textContent = '';
          //physcial row car le tri et les filtres peuvent changer l'ordre des lignes
          let physicalRow = instance.toPhysicalRow(row);
          let miniliens = self.ressources[physicalRow].miniliens;
          if (miniliens?.length >= 1) {
            const miniliensString = miniliens
              // on prends que les miniliens pearltrees
              .filter((minilien) => minilien.type_minilien === 'pearltrees')
              // on affiche que les url courtes
              .map((minilien) => minilien.url_courte)
              // on les sépare par un saut de ligne
              .join('<br>');
            td.innerHTML = miniliensString;
          }
          return td;
        },
      },
      {
        data: 'modificationDateFormatted',
        title: 'Dernière modification',
        width: 160,
        readOnly: true,
        type: 'text',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'commentaires',
        title: 'Commentaires',
        readOnly: !this.userService.canEdit(),
        type: 'text',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
      },
      {
        data: 'minilienEdubelin',
        title: 'Forcer edubelin',
        width: 120,
        readOnly: !this.userService.canEdit(),
        type: 'checkbox',
        className: this.userService.canEdit() ? 'label' : 'label desactive',
        renderer: (instance, td, row, col, prop, value, cellProperties) => {
          let physicalRow = instance.toPhysicalRow(row);
          if (self.ressources[physicalRow]?.ouvrage?.is_reprise) {
            td.innerHTML =
              '<input class="htCheckboxRendererInput" ' +
              'type="checkbox" autocomplete="off" tabindex="-1" data-row="' +
              row +
              '" ' +
              'data-col="' +
              col +
              '" ' +
              (value ? 'checked' : '') +
              '>';
          }
          // pas de else car la colonne est cachée si ce n'est pas une reprise
          return td;
        },
      },
    ];
  }

  private initSettings(): void {
    registerLanguageDictionary(frFR);
    var self = this;
    this.settings = {
      renderAllRows: false,
      viewportColumnRenderingOffset: 40, // Force toutes les colonnes à être rendu
      height: 500,
      rowHeights: 40,
      autoColumnSize: {
        useHeaders: true,
        syncLimit: '100%',
      },
      width: '100%',
      allowInsertRow: true,
      filters: true,
      modifyFiltersMultiSelectValue(value, meta) {
        if (meta.prop === 'categorie') {
          const category = self.categories.find(
            (c: any) => String(c.value) === String(value),
          );
          return category ? category.key : value;
        }
        if (meta.prop === 'format.id') {
          const format = self.formats.find(
            (f: any) => String(f.value) === String(value),
          );
          return format ? format.key : value;
        }
        return value;
      },
      fillHandle: {
        autoInsertRow: false,
        direction: 'vertical',
      },
      trimDropdown: false,
      comments: true,
      dropdownMenu: [
        'filter_by_condition',
        'filter_by_value',
        'filter_action_bar',
      ],
      contextMenu: {
        items: {
          row_below: {
            name: 'Insérer une ligne en dessous',
            disabled() {
              return self.isDegradedMod;
            },
          },
          delete_row: {
            name: 'Supprimer la ressource',
            disabled() {
              if (self.isDegradedMod) {
                return true;
              }
              if (typeof this !== 'undefined') {
                let selected = this.getSelectedLast() as Array<any>;
                let row = selected[0];
                let ressource = self.ressources[this.toPhysicalRow(row)];
                let ejected = ['', undefined, null];
                if (
                  !ejected.includes(ressource.titreEditeur) ||
                  !ejected.includes(ressource.numeroFolio)
                ) {
                  return true;
                }
              }

              return false;
            },
            callback(key, selection, clickEvent) {
              let instance = self.hotRegisterer.getInstance(self.idTable);
              let deleteFunctions: Array<Observable<any>> = [];

              for (
                let i = selection[0]['start']['row'];
                i <= selection[0]['end']['row'];
                i++
              ) {
                let id = self.ressources[instance.toPhysicalRow(i)].id;
                // self.deleteRessourceNumerique
                const deleteFunction = new Observable((observer) => {
                  self.ressourceNumeriqueService.delete(id).subscribe({
                    next: (data) => {
                      let physicalRow = self.ressources.findIndex(
                        (ressource) => ressource.id === id,
                      );
                      if (physicalRow !== -1) {
                        instance.alter(
                          'remove_row',
                          instance.toVisualRow(physicalRow),
                          1,
                        );
                      }
                      observer.next();
                      observer.complete();
                    },
                    error: (err) => {
                      observer.next();
                      observer.complete();
                    },
                  });
                });

                deleteFunctions.push(deleteFunction);
              }

              forkJoin(deleteFunctions).subscribe({
                next: (value) => {
                  // self.loadRessourcesNumeriques()
                },
                error: (err) => {},
              });
            },
          },
          file_upload: {
            name: 'Uploader un fichier',
            disabled() {
              if (self.isDegradedMod) {
                return true;
              }
              if (typeof this !== 'undefined') {
                let selected = this.getSelectedLast() as Array<any>;
                let row = selected[0];
                let ressource = self.ressources[this.toPhysicalRow(row)];
                let ejected = ['', undefined, null];
                if (!ressource.verouille) {
                  return true;
                }
              }

              return false;
            },
            callback(key, selection, clickEvent) {
              let row = selection[0]['start']['row'];
              let physicalRow = self.hotRegisterer
                .getInstance(self.idTable)
                .toPhysicalRow(row);
              let id = self.ressources[physicalRow].id;

              var idSelector = 'fileUploadDialog_' + id;

              let dialog = document.getElementById(
                idSelector,
              ) as HTMLDialogElement;

              dialog.showModal();
            },
          },
          edit_text: {
            name: 'Editer le titre',
            callback(key, selection, clickEvent) {
              let row = selection[0]['start']['row'];
              let physicalRow = self.hotRegisterer
                .getInstance(self.idTable)
                .toPhysicalRow(row);
              let id = self.ressources[physicalRow].id;
              const titreColumnId = self.columns.findIndex(
                (c) => c.data === 'titreEditeur',
              );
              let coords: CellCoords = new CellCoords(row, titreColumnId);

              self.idTextEditor = coords;
              self.display = true;
              self.text = self.ressources[physicalRow]['titreEditeur'] as string;
            },
            disabled() {
              return self.isDegradedMod;
            },
          },
        },
      },
      selectionMode: 'multiple',
      copyPaste: true,
      columnSorting: false,
      licenseKey: environment.hotLicenseKey,
      currentRowClassName: 'row-selected',
      language: frFR.languageCode,

      colHeaders: (index) => {
        return index == 1 ? '' : self.columns[index - 1].title;
      },
      // probleme perf
      // afterRenderer: (TD, row, col, prop, value, cellProperties) => {
      //   if (row === self.currentRowIndex) {
      //     TD.classList.add('row-selected');
      //   } else {
      //     TD.classList.remove('row-selected');
      //   }
      // },
      afterOnCellMouseDown: (event, coords, TD: HTMLTableCellElement) => {
        this.targetCell = TD;
        let target = event.target as HTMLElement;

        if (target.className.includes('rn_fileupload')) {
          var id = target.dataset.id;
          var idSelector = 'fileUploadDialog_' + id;

          let dialog = document.getElementById(idSelector) as HTMLDialogElement;

          dialog.showModal();
        }
        if (target.className.includes('rn_filedownload')) {
          var id = target.dataset.id;

          this.downloadFile(id);
        }

        if (target.className.includes('copy_to_clipboard')) {
          let physicalRow = self.hotRegisterer
            .getInstance(self.idTable)
            .toPhysicalRow(coords.row);
          let filenameText = self.ressources[physicalRow].filename.replace(
            /<url>$/,
            '.mp4',
          );
          navigator.clipboard.writeText(filenameText);
        }

        //prévisualisation uniquement pour les ressources avec fichier, pas de prévisualisation pour les url
        if (target.className.includes('b-preview')) {
          let physicalRow = self.hotRegisterer
            .getInstance(self.idTable)
            .toPhysicalRow(coords.row);
          let fileName = self.ressources[physicalRow].filename;
          if (fileName) {
            const backUrl = environment.apiUrl;
            const url = backUrl + '/' + fileName;
            window.open(url, '_blank');
          }
        }

        if (self.userService.canEdit()) {
          let physicalRow = self.hotRegisterer
            .getInstance(self.idTable)
            .toPhysicalRow(coords.row);

          if (this.targetCell.classList.contains('show_categories')) {
            // this handle only necessary columns with special class
            self.displayCategories = true;
            self.selectedCategorie = self.ressources[physicalRow][
              'categorie'
            ] as string;
            self.idTextEditor = coords;
          }

          if (this.targetCell.classList.contains('show_formats')) {
            // this handle only necessary columns with special class
            self.displayFormats = true;
            self.selectedFormat =
              typeof self.ressources[physicalRow]['format'] !== 'undefined'
                ? self.ressources[physicalRow]['format']['id']
                : null;
            self.idTextEditor = coords;
          }

          if (this.targetCell.classList.contains('show_pages')) {
            // this handle only necessary columns with special class
            self.displayPages = true;
            self.selectedPage =
              self.ressources[physicalRow]['pagesIds'] !== null
                ? self.ressources[physicalRow]['pagesIds'].split(',')
                : null;
            self.idTextEditor = coords;
          }

          if (this.targetCell.classList.contains('show_cible')) {
            // this handle only necessary columns with special class
            self.displayCible = true;
            self.selectedCible = self.ressources[physicalRow]['cible'] as string;
            self.idTextEditor = coords;
          }
        }
      },
      beforeChange: function (changes, source) {
        const dataChanges = changes[0];
        if (!self.userService.canEdit()) {
          return false;
        } else {
          if (dataChanges) {
            const colNames = dataChanges[1]; // valeur présente dans le proprété data des column dans initColumn
            const newValue = dataChanges[3];
            if (newValue === null || newValue === undefined) {
              //dataChanges[3] = '4'
            }
            switch (colNames) {
              case 'pagesIds':
                let valueArray = newValue
                  .split(',')
                  .filter((element) => element !== '');
                return (
                  valueArray.length == 0 ||
                  (valueArray.length > 0 &&
                    valueArray.every((element) =>
                      self.pages.some((page) => page.pageId === element),
                    ))
                );
                break;
              case 'categorie':
                if (self.categories.some((obj) => obj.value === newValue)) {
                  return true;
                } else {
                  return false;
                }
                break;
              case 'format.id':
                if (
                  self.formats.some((obj) => obj.value === newValue) ||
                  self.formats.some((obj) => obj.key === newValue)
                ) {
                  return true;
                } else return false;
                break;
              case 'cible':
                if (self.cibles.some((obj) => obj.value === newValue)) {
                  return true;
                } else return false;
                break;
              default:
                return true; // return true car c'est les autres colonnes
                break;
            }
          }
          return true;
        }
      },
      afterSelection(row, column) {
        self.currentRowIndex = row;
        const hot = self.hotRegisterer.getInstance(self.idTable);
        hot.render();
      },
      // Pas de `afterChange` ici : ce settings object est fusionné dans
      // handsontable.component.ts via `{...wrapperSettings, ...settings}`,
      // donc une clé `afterChange` définie ici écraserait celle du wrapper
      // (qui calcule dataChanges et émet onDataChange) au lieu de s'y
      // ajouter. Voir registerStructureFolioChangeHook() qui s'enregistre
      // via instance.addHook() à la place.
      beforeOnCellMouseDown: (event, coords, TD) => {
        const type = event.target?.['attributes']?.type;
        if (type?.value === 'checkbox') {
          event.preventDefault(); // Empêche le changement d'état par défaut
          const hotInstance = this.hotRegisterer.getInstance(this.idTable);
          const cellValue = hotInstance.getDataAtCell(coords.row, coords.col);
          const newValue = !cellValue;
          hotInstance.setDataAtCell(coords.row, coords.col, newValue);
          this.ressources[hotInstance.toPhysicalRow(coords.row)][
            this.columns[coords.col].data
          ] = newValue;
        }
      },
      //desactivation temporaire le temps de touver le fix
      //car trop gourmand en perf
      // afterGetColHeader: (col, TH) => {
      //   TH.title = this.colToolTip[col] || '';
      //   if (col === 1) {
      //     //supression bouton pour la colonne 1
      //     const button = TH.querySelector('.changeType');
      //     if (!button) {
      //       return;
      //     }
      //     button.parentElement?.removeChild(button);
      //     TH.classList.add('comment-col-header');
      //   }
      // },
    };

    const hiddenColumnsIds: number[] = [0];

    if (!this.userService.canEdit()) {
      const indexColumn = this.columns.findIndex(
        (c) => c.metaTitle === 'Prévisualisation',
      );
      hiddenColumnsIds.push(indexColumn);
    }
    this.settings.hiddenColumns = { columns: hiddenColumnsIds };
  }

  private async loadCategories() {
    return new Promise((resolve) => {
      this.categories = this.classDef.fdef['categorie']['options'];
      resolve(true);
    });
  }

  private async loadFormats() {
    return new Promise((resolve) => {
      this.formats = [];
      this.formatService
        .watch()
        .valueChanges.pipe(
          map((result) => result.data.getFormatListing),
          extractEdgesAndNodes(),
        )
        .subscribe({
          next: (value) => {
            for (const entry of value) {
              let format = { key: entry.nom, value: entry.id };
              this.formats.push(format);
            }
            resolve(true);
          },
          error: (err) => {
            resolve(false);
          },
        });
    });
  }

  private async loadCibles() {
    return new Promise((resolve) => {
      this.cibles = this.classDef.fdef['cible']['options'];
      resolve(true);
    });
  }

  private loadDataList(): Observable<boolean> {
    this.classDefinition.load().then(() => {
      this.classDef = this.classDefinition.getByName('RessourceNumerique');
      Promise.all([
        this.loadFormats(),
        this.loadCategories(),
        this.loadCibles(),
      ]).then(() => {
        this.loadPages();
        this.initColumns();
        this.updateHiddenColumns(this.isReprise);
      });
    });

    return of(true);
  }

  private updateHiddenColumns(isReprise: boolean): void {
    const instance = this.hotRegisterer.getInstance(this.idTable);
    if (!instance || !this.columns || this.columns.length === 0) {
      console.warn('Les colonnes ne sont pas encore initialisées.');
      return;
    }

    const edubelinColumnIndex = this.columns.findIndex(
      (c) => c.data === 'minilienEdubelin',
    );
    let hiddenColumns = [0];

    if (!this.userService.canEdit()) {
      const previewColumnIndex = this.columns.findIndex(
        (c) => c.metaTitle === 'Prévisualisation',
      );
      if (previewColumnIndex !== -1) {
        hiddenColumns.push(previewColumnIndex);
      }
    }

    if (!isReprise && edubelinColumnIndex !== -1) {
      hiddenColumns.push(edubelinColumnIndex);
    }

    instance.updateSettings({
      hiddenColumns: { columns: hiddenColumns },
    });
  }

  removePage(idPage: number): void {
    this.pages = this.pages.filter((page) => page.pageId !== idPage);
  }

  getHotInstance(): Handsontable {
    if (!this.hotInstance) {
      this.hotInstance = this.hotRegisterer.getInstance(this.idTable);
    }
    return this.hotInstance;
  }
}

// améliorer la perf après une sauvegarde
// sauvegarde qui revient malgré la supression
